/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:1b809ca1-5e8e-4659-8810-8670c59a2355",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_4o3eFGy0X",
    "aws_user_pools_web_client_id": "2oc2a3285vc6bcaikmil1qn3fm",
    "oauth": {
        "domain": "cerebrof0ae59c5-f0ae59c5-tkadmindev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:4200/",
        "redirectSignOut": "http://localhost:4200/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://5kxgzg3najewdekqvfqpdoowry.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_content_delivery_bucket": "cerebro-20210830145403-hostingbucket-tkadmindev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dr8vb2wb89u4.cloudfront.net",
    "aws_user_files_s3_bucket": "cerebrof262a19db4a8471085838587b3fdcdf7160520-tkadmindev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_login_mechanism": [],
    "aws_cognito_login_mechanisms": []
};


export default awsmobile;
